<dx-popup title="Recurring Job" [width]="400" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false">
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="recurringJob" validationGroup="mainValidationGroup" [colCount]="2">
        <dxi-form-item dataField="frequency" editorType="dxNumberBox" [label]="{ text: 'Repeat Every' }">
            <dxi-form-validation-rule type="range" [min]="1" message="Must be greater than one"> </dxi-form-validation-rule>
            <dxi-form-validation-rule type="required"></dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item
            dataField="frequencyUnit"
            editorType="dxSelectBox"
            [editorOptions]="{ items: frequencyTypeOptions }"
            [label]="{ text: ' ' }"
        >
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="endDate" editorType="dxDateBox" [colSpan]="2" [label]="{ text: 'Ending On' }">
            <dxi-form-validation-rule type="range" [max]="maxDate" message="Date must be less than five years in the future">
            </dxi-form-validation-rule>
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
    </dx-form>
</dx-popup>
